<template>
  <div>
    <v-card-title>
      <h4>{{ $t('expert.schedule.title') }}</h4>
    </v-card-title>

    <v-card-text>
      <span class="subheading">{{ $t('expert.schedule.timezone') }}: </span>
      {{ expert.timezone }}
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="schedule"
      :custom-sort="a => a"
      hide-actions>
      <template slot="items" scope="props">
        <td>{{ $t(`expert.schedule.days.${props.item.day}`) }}</td>
        <td>{{ props.item.from }}</td>
        <td>{{ props.item.to }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import expert from '@/mixins/expert'
  export default {
    mixins: [expert],
    computed: {
      headers () {
        return [
          { text: this.$t('expert.schedule.header.day'), left: true, sortable: false },
          { text: this.$t('expert.schedule.header.from'), left: true, sortable: false },
          { text: this.$t('expert.schedule.header.to'), left: true, sortable: false }
        ]
      },
      schedule () {
        const valid = (x) => x.from !== null && x.to !== null
        return [...this.expert.schedule].filter(valid).sort((a, b) => {
          if (a.day === b.day) {
            return a.from.localeCompare(b.from)
          } else {
            return a.day - b.day
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/expert/Schedule.vue